import { Injectable } from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class RecycleCommandsService {

  constructor(private commonService: CommonService) { }

  async fetchRecycleCommand(recordId: number) {
    return await this.commonService.getSimpleList(`recycle_command/${recordId}`);
  }

  async insertRecycleCommand(model: any) {
    return await this.commonService.insertObject(`recycle_command`, model);
  }

  async completeRecycleCommand(recordId: number, model) {
    return await this.commonService.updateObject(`recycle_command/complete/${recordId}`, model);
  }

  async assignRecycleCommand(data) {
    return await this.commonService.updateObject(`recycle_command/routing`, data);
  }

  async fetchUsersForAssign(recordId: number) {
    return await this.commonService.getSimpleList(`recycle_command/users?id=${recordId}`);
  }
}
